import httpFactory, { HttpType } from "@/api/httpFactory";
export default {
    async getAll() {
        const http = httpFactory.getHttp(HttpType.Api);
        const response = await http.get("service-marketing-categories");
        return response.data;
    },
    async get(id) {
        const http = httpFactory.getHttp(HttpType.Api);
        const response = await http.get(`service-marketing-categories/${id}`);
        return response.data;
    },
    async create(request) {
        const http = httpFactory.getHttp(HttpType.Api);
        const response = await http.post("service-marketing-categories", request);
        return response.data;
    },
    async edit(id, request) {
        const http = httpFactory.getHttp(HttpType.Api);
        const response = await http.post(`service-marketing-categories/${id}`, request);
        return response.data;
    }
};
